<nb-form-field [nbSpinner]="loading">
    <input
        nbInput
        fullWidth
        nbPreffix
        #input
        type="text"
        (keyup)="onInputChange$.next(input.value)"
        placeholder="{{ 'INPUT-PLACEHOLDERS.SEARCH-DOUBLE' | translate }}"
        [nbAutocomplete]="auto"
    />
    <nb-icon icon="search" nbSuffix></nb-icon>
</nb-form-field>
<nb-autocomplete #auto (selectedChange)="onSelectionChange($event)" [handleDisplayFn]="getValueFromObject">
    <nb-option *ngFor="let option of result" [value]="option">
        {{ option?.nome_completo }}
    </nb-option>
</nb-autocomplete>
